<template>
  <div class="wrap">
    <div class="main_con fadeInUp animated" v-if="aboutData">
      <div class="breadcrumb_con flex-display">
        <el-breadcrumb separator="/">
          <i class="el-icon-location-outline left icon-location"></i>
          <span class="left">{{ $t("common.CurrentLocation") }}：</span>
          <el-breadcrumb-item
            ><router-link to="/Home">{{
              $t("common.Glang")
            }}</router-link></el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ $t("top.About") }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-divider></el-divider>
      <img
        class="header_img"
        v-if="aboutData.head_img"
        :src="img_head_url + aboutData.head_img.src"
      />
      <div class="about_con">
        <el-card
          shadow="hover"
          class="card_con"
          id="Company_Profile"
          v-if="aboutData.jianjie"
        >
          <el-row :gutter="0" style="margin-bottom: 40px">
            <el-col :span="24">
              <div class="con_title_small">{{ $t("top.Company_Profile") }}</div>
              <div
                style="white-space: pre-wrap"
                v-html="aboutData.jianjie.text"
              ></div>
            </el-col>
          </el-row>
          <div style="clear: both"></div>
        </el-card>
        <el-card
          shadow="hover"
          class="card_con"
          id="Corporate_philosophy"
          v-if="aboutData.linian"
        >
          <el-row :gutter="0" style="margin-bottom: 40px">
            <el-col :span="24">
              <div class="con_title_small">
                {{ $t("top.Corporate_philosophy") }}
              </div>
              <div
                style="white-space: pre-wrap"
                v-html="aboutData.linian.text"
              ></div>
            </el-col>
          </el-row>
        </el-card>
        <el-card
          shadow="hover"
          class="card_con"
          id="Corporate_Honors"
          v-if="aboutData.rongyu"
        >
          <el-row :gutter="0" style="margin-bottom: 40px">
            <el-col :span="24">
              <div class="con_title_small">
                {{ $t("top.Corporate_Honors") }}
              </div>
              <div
                style="white-space: pre-wrap"
                v-html="aboutData.rongyu.text"
              ></div>
            </el-col>
          </el-row>
        </el-card>
        <el-card
          shadow="hover"
          class="card_con"
          id="Company_Scenarios"
          v-if="aboutData.changjing"
        >
          <el-row :gutter="0" style="margin-bottom: 40px">
            <el-col :span="24">
              <div class="con_title_small">
                {{ $t("top.Company_Scenarios") }}
              </div>
              <div
                style="white-space: pre-wrap"
                v-html="aboutData.changjing.text"
              ></div>
            </el-col>
          </el-row>
        </el-card>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 监听,当路由发生变化的时候执行
  watch: {
    $route (to, from) {
      var that = this
      console.log(to.query.page)
      that.index = to.query.page || 0
      that.scrollToPosition()
    }
  },
  components: {},
  data () {
    return {
      img_head_url: '',
      aboutData: {},
      lang: localStorage.lang || 'cn',
      index: 0
    }
  },
  created () {
    var that = this
    console.log('created')
    that.index = that.$route.query.page || 0
    this.getAboutData()
  },
  mounted () {
    console.log('mounted')
  },
  methods: {
    getAboutData () {
      var that = this
      var json = {
        lang: that.lang
      }
      var url = '/api/get_about_us'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log(res)
        if (res.meta.status === 200) {
          that.aboutData = res.data
          that.img_head_url = res.img_head_url
        }
        that.scrollToPosition()
      })
    },
    scrollToPosition () {
      var that = this
      var index = that.index
      console.log(index)
      setTimeout(() => {
        if (index === 1 || index === '1') {
          console.log('Company_Profile')
          this.$scrollTo('#Company_Profile')
        } else if (index === 2 || index === '2') {
          console.log('Corporate_philosophy')
          this.$scrollTo('#Corporate_philosophy')
        } else if (index === 3 || index === '3') {
          console.log('Corporate_Honors')
          this.$scrollTo('#Corporate_Honors')
        } else if (index === 4 || index === '4') {
          console.log('Company_Scenarios')
          this.$scrollTo('#Company_Scenarios')
        }
      }, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.about_con{
  background-color: #fff;
  padding: 0 50px 100px;
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
}
.card_con {
  display: block;
  width: 1200px;
  margin: 20px auto;
  position: relative;
  text-align: left;
  border: none;
  padding-top: 80px;
}
.card_con:hover {
  box-shadow: none;
  -webkit-box-shadow: none;
}
::v-deep .card_con img {
  width: 100%;
  height: auto;
}
.el-card__body{
  padding: 0;
}

// .teamer_img {
//   width: 100%;
//   margin: 0 auto;
//   height: auto;
// }
</style>
